module.exports = __webpack_public_path__ + "media/react/assets/TeamGoals-ab0b1a1b0924a0a7e3b00696491db024.svg";